module.exports = __webpack_public_path__ + "media/3-12.bf2a1079.wav";